<ng-container *ngIf="!confirm">
    <h2>Supprimer toutes les données</h2>
    <p>Souhaitez-vous réellement supprimer toutes les données ? <br> Attention cette action supprime tous les <strong>encodages</strong> et les <strong>camions Clicotte</strong>.</p>
    <div class="btn_action">
        <button class="back" (click)="dialogRef.close()">Annuler</button>
        <button class="confirm" (click)="confirmAction()">Confirmer</button>
    </div>
</ng-container>

<app-validation-animation [text]="'Données supprimées'" *ngIf="confirm"></app-validation-animation>